export const messages = {
    invoice: {
        date: 'Date',
        dueDate: 'Due Date',
        paymentTerms: 'Payment Terms',
        paymentDays: 'Payment Days',
        days: 'days',
        workingDraft: 'Working Draft',
        invoiceFor: 'Invoice for {company}',
        pagination: 'Page {page} of {total}',
        lineItems: {
            description: 'Description',
            quantity: 'QTY',
            price: 'Price',
            vatRate: 'VAT Rate',
            amount: 'Amount',
            add: 'Add Item',
            remove: 'Remove',
        },
        subtotal: 'Subtotal',
        vat: 'VAT',
        total: 'Total',
        status: 'Status',
        discount: {
            add: 'Add discount',
            display: 'Discount: {value}',
            percentage: 'Percentage',
            fixed: 'Fixed Amount',
            none: 'No Discount',
            label: 'Discount',
            edit: 'Edit discount'
        },
        from: 'From',
        to: 'To',
        number: 'Invoice Number',
        notes: 'Notes',
        company: 'Company',
        address: 'Address',
        postalCode: 'Postal Code',
        city: 'City',
        additionalInfo: 'Additional Info',
        vatNumber: 'VAT Number',
        kvkNumber: 'Chamber of Commerce Number',
        kvk: 'Chamber of Commerce',
        btw: 'VAT',
        title: 'INVOICE',
        nonEditableTitle: 'Invoice Cannot Be Edited',
        sentNonEditableMessage: 'This invoice has been sent and can no longer be edited to maintain records integrity.',
        paidNonEditableMessage: 'This invoice has been paid and can no longer be edited to maintain records integrity.',
        useCommandBarMessage: 'You can view history or delete the invoice using the command bar below.',
        history: {
            created: 'Invoice Created',
            createdDescription: 'Invoice #{invoiceNumber} was created',
            saved: 'Invoice Saved',
            savedDescription: 'Invoice was saved and is ready to be sent',
            updated: 'Invoice Updated',
            updatedDescription: 'Invoice details were modified',
            paymentReceived: 'Payment was received for this invoice',
            paymentReceivedFromProvider: '{provider} payment received',
            paymentReceivedFromProviderDescription: 'Payment was processed by {provider}',
            markedPaidDescription: 'Invoice was marked as paid',
            overdueDescription: 'Invoice became overdue on the due date',
            reminderSent: 'Payment Reminder Sent',
            reminderSentDescription: 'Payment reminder was sent to {email}',
            subtitle: 'Activity timeline for this invoice',
            loadError: 'Unable to load history',
            loadErrorDescription: 'We encountered a problem loading your invoice history.',
            empty: 'No history yet',
            emptyDescription: 'Your invoice history will appear here as changes are made and emails are sent.'
        },
        paymentMethods: {
            title: 'Payment Method',
            add: 'Add Payment Method',
            edit: 'Edit Payment Method',
            none: 'None',
            enabled: 'Enable this payment method',
            online: 'Pay this invoice online:',
            alternative: 'Or pay this invoice securely online:',
            onlineOnly: 'Please pay this invoice within {days} days using the secure option below:',
            notSure: 'Not sure if you paid? Check the status here',
            payNow: 'Pay Now',
            setAsDefault: 'Add as default for future invoices',
            bank: {
                title: 'Bank Transfer',
                iban: 'IBAN',
                bic: 'BIC/SWIFT (optional)',
                accountName: 'Account Name',
                paymentInstructionWithDays: 'We kindly ask you to make payment within {days} days to:',
                reference: 'Reference',
                includeReference: 'Please include the reference number when making your payment'
            },
            paypal: {
                title: 'PayPal',
                email: 'PayPal Email'
            },
            mollie: {
                title: 'Mollie',
                apiKey: 'Mollie API Key',
                description: 'Payment Description',
                connected: 'Connected to Mollie',
                reconnect: 'Reconnect',
                connect: 'Connect with Mollie',
                connecting: 'Connecting...',
                explain: 'Connect your Mollie account to accept online payments directly through your invoices',
                readyToReceive: 'Ready to receive online payments'
            },
            stripe: {
                title: 'Stripe',
                accountId: 'Stripe Account ID',
                description: 'Payment Description'
            }
        },
        saveAsDefault: 'Save as default for new invoices',
        paymentDate: 'Marked paid at',
        languageNotice: 'Your interface is in {interfaceLanguage}, but the invoice preview and email will be sent in {invoiceLanguage}',
    },
    overlay: {
        recently: 'Recently',
        paymentReceived: 'Payment received',
        invoiceSent: 'Invoice sent',
        readOnly: 'Read-only',
        editingDisabled: 'Editing is disabled'
    },
    status: {
        concept: 'Draft',
        saved: 'Saved',
        sent: 'Sent',
    },
    payment: {
        status: {
            unpaid: 'Unpaid',
            paid: 'Paid',
            markedPaid: 'Marked Paid',
            overdue: 'Overdue',
            overdue_reminded: 'Reminder Sent',
            reminderSent: 'Reminder sent {date}',
            canceled: 'Canceled',
            failed: 'Failed'
        },
        updateStatus: 'Update Payment Status',
        filter: {
            all: 'All Invoices',
            planned: 'Planned'
        }
    },
    errors: {
        pdfGenerationFailed: 'Failed to generate PDF. Please try again.',
    },
    actions: {
        actions: 'Actions',
        generatingPDF: 'Generating PDF...',
        delete: 'Delete',
        edit: 'Edit',
        save: 'Save',
        cancel: 'Cancel',
        confirm: 'Confirm',
        copy: 'Copy',
        download: 'Download',
        send: 'Send',
        close: 'Close',
        clickToEdit: 'Click to edit',
        new: 'New',
        exportPDF: 'Export PDF',
        sendInvoice: 'Send Invoice',
        saveInvoice: 'Save Invoice',
        done: 'Done',
        previewSend: 'Preview Send',
        sendReminder: 'Send Reminder',
        sendingReminder: 'Sending Reminder...',
        reminderSent: 'Reminder Sent',
        reminderCooldown: 'Next reminder available in {hours}h {minutes}m'
    },
    settings: {
        title: 'Settings',
        language: 'Language',
        invoiceLanguage: 'Send invoices in language:',
        country: 'Default VAT Country',
        logo: {
            title: 'Company Logo',
            placeholder: 'Upload a company logo',
            dropHere: 'Drop your logo here',
            clickOrDrop: 'Click or drop logo',
            uploading: 'Uploading logo...',
            invalidType: 'Invalid file type. Only JPG, PNG, WEBP and SVG are allowed.',
            tooLarge: 'File too large. Maximum size is 2MB.',
            uploadFailed: 'Failed to upload logo. Please try again.',
            deleteFailed: 'Failed to delete logo. Please try again.',
            confirmDelete: 'Are you sure you want to remove your logo?',
            loginRequired: 'You need to login to upload a logo'
        },
        invoiceNumber: {
            title: 'Invoice Number Format',
            preview: 'Next invoice will be',
            prefix: 'Prefix',
            prefixPlaceholder: 'e.g. INV',
            includeYear: 'Include Year',
            yearFormat: 'Year Format',
            yearFormatFull: 'Full Year',
            yearFormatShort: 'Short Year',
            separator: 'Separator',
            noSeparator: 'None',
            numberPadding: 'Number Length',
            numberPaddingHelp: 'Length of the sequential number',
            resetToDefault: 'Reset to Default'
        },
        languageNotice: 'Your interface is in {interfaceLanguage}, but invoices will be sent in {invoiceLanguage}. See email preview.'
    },
    dialog: {
        deleteInvoice: {
            title: 'Delete Invoice',
            message: 'Are you sure you want to delete this invoice? This action cannot be undone.',
        },
        deleteCompany: {
            title: 'Delete Company',
            message: 'Are you sure you want to delete this company? This action cannot be undone.',
        },
        saveSuccess: {
            title: 'Invoice Saved!',
            message: 'Your invoice has been successfully saved.',
            newInvoice: 'New Invoice',
            viewInvoice: 'View Invoice',
        },
    },
    placeholders: {
        enterPaymentTerms: 'Enter payment terms',
        dueDateWillBe: 'Due date will be {date}',
        pastDateWarning: 'This date is in the past',
        addDetails: 'Add your details',
    },
    paymentTerms: {
        '7 days': '7 days',
        '14 days': '14 days',
        '30 days': '30 days',
        '60 days': '60 days',
        'Due on receipt': 'Due on receipt',
    },
    landing: {
        title: 'Invoice in seconds. Pay Nothing.',
        headerTitle: 'InvoiceHappens',
        subtitle: '100% free for the first 100,000 entrepreneurs. Start now below',
        madeBy: 'crafted by @sanderbz',
        invoiceNumber: 'Invoice Number: {number}',
        tagline: '*poof* an invoice',
        contact: 'Contact Us',
        getInTouch: 'Get in Touch',
        contactDescription: 'Have questions or need assistance? We\'re here to help. Reach out to our team using any of the methods below.',
        joinCommunity: 'Join Our Community',
        communityDescription: 'Connect with us on social media to stay updated on the latest features, tips, and news about InvoiceHappens.'
    },
    overview: {
        title: 'Your Invoices',
        emptyTitle: 'No invoices yet',
        emptyDescription: 'Your invoices will appear here. Start by creating a new invoice.',
        emptyFilterDescriptions: {
            all: 'Your invoices will appear here. Start by creating a new invoice.',
            unpaid: 'No unpaid invoices found. All your invoices have been paid!',
            paid: 'No paid invoices found yet.',
            overdue: 'No overdue invoices found. Great job staying on top of payments!',
            overdue_reminded: 'No reminded invoices found.',
        },
        totalCount: '{count} {count, plural, one {invoice} other {invoices}} total'
    },
    company: {
        saveAsDefault: 'Save as default',
        useAsFrom: 'Use as From',
        editDetails: 'Edit Company Details',
        yourCompany: 'Your Company',
        name: 'Company Name',
        address: 'Address',
        city: 'City',
        contactName: 'Contact Name',
        createdAt: 'Created At',
        createNew: 'Create new company: {name}',
        noResults: 'No companies found',
        recentCompanies: 'Recent companies',
        noRecentCompanies: 'No recent companies found',
        select: 'Select a company',
        creating: 'Creating company...',
        created: 'Company created!',
        clearSelection: 'Clear company selection',
    },
    auth: {
        welcome: 'Save Your Work',
        signInToContinue: 'Connect to save your invoices in the cloud',
        continueWithGoogle: 'Continue with Google',
        continueWithMicrosoft: 'Continue with Microsoft',
        privacyNotice: 'By continuing, you agree to our Terms of Service and Privacy Policy',
        signOut: 'Sign Out',
        user: 'User',
        signIn: 'Login or Register',
        secureTitle: 'Secure Your Work',
        secureDescription: 'Keep your invoices safe and accessible from anywhere. Connect to ensure your work is automatically backed up and never lost, even if you clear your browser data.',
        autoSave: 'Automatic cloud backup',
        browserWarning: 'Protected from data loss',
        signedInAs: 'Connected as',
        browserOnly: 'Browser only',
        clearCacheWarning: 'Clear cache = lose data',
        neverLoseWork: 'Never lose your work',
        autoSaveCloud: 'Auto-save to cloud',
        freeAccount: 'It\'s completely free!',
        welcomeBar: {
            title: 'Already created invoices before?',
            description: 'Sign in to access your saved invoices on this device',
            signIn: 'Sign in'
        },
        loginRequired: {
            logo: {
                title: 'Upload Your Logo',
                description: 'You need to login to upload and save your company logo.'
            },
            mollie: {
                title: 'Connect with Mollie',
                description: 'You need to login to connect with Mollie for online payments.'
            },
            email: {
                title: 'Send Invoices via Email',
                description: 'You need to login to send invoices via email to your clients.'
            }
        }
    },
    admin: {
        menuItem: 'Admin Dashboard',
        title: 'Admin Dashboard',
        backToHome: 'Back to Home',
        backToUsers: 'Back to Users',
        backToAdmin: 'Back to Admin',
        backToInvoices: 'Back to Invoices',
        lastChanged: 'Last changed {time}',
        invoiceDetails: {
            title: 'Invoice {number}',
            subtitle: 'Created by {email}',
            rawData: 'Raw Data'
        },
        emails: {
            title: 'Email Queue',
            queueTitle: 'Recent Emails',
            viewQueue: 'View Email Queue',
            refresh: 'Refresh',
            total: 'Total Emails',
            planned: 'Planned',
            sent: 'Sent',
            invoiceNumber: 'Invoice',
            user: 'User',
            recipient: 'Recipient',
            status: {
                sent: 'Sent',
                planned: 'Planned',
                failed: 'Failed'
            },
            scheduled: 'Scheduled At',
            attempts: 'Attempts'
        },
        users: {
            title: 'Users',
            email: 'Email',
            company: 'Company',
            invoices: 'Invoices',
            joined: 'Joined',
            lastActive: 'Last Active',
            actions: 'Actions',
            viewInvoices: 'Invoices',
            viewCompanies: 'Companies',
            viewSettings: 'Settings',
            viewSchedules: 'Schedules',
            settings: 'User Settings',
            noSettings: 'No settings found',
            activeToday: 'Active Today',
            totalInvoices: 'Total Invoices'
        },
        userInvoices: {
            title: 'Invoices for {email}',
            invoices: 'Invoices',
            noInvoices: 'No invoices found',
            loadMore: 'Load more',
            previewEmail: 'Preview Email',
            emailPreview: 'Email Preview for Invoice {invoiceNumber}',
            loadingEmail: 'Loading email preview...'
        },
        userCompanies: {
            title: 'Companies for {email}',
            companies: 'Companies',
            noCompanies: 'No companies found'
        },
        userSchedules: {
            title: 'Schedules for {email}',
            schedules: 'Schedules',
            noSchedules: 'No schedules found',
            templateInvoice: 'Template Invoice',
            type: 'Type',
            startDate: 'Start Date',
            endDate: 'End Date',
            lastGenerated: 'Last Generated',
            nextDate: 'Next Date',
            status: 'Status',
            active: 'Active',
            inactive: 'Inactive'
        }
    },
    common: {
        loading: 'Loading...',
        refresh: 'Refresh',
        refreshing: 'Refreshing...',
        error: 'An error occurred',
        yes: 'Yes',
        no: 'No',
        close: 'Close',
        actions: 'Actions',
        now: 'Now'
    },
    email: {
        sendInvoice: 'Send Invoice',
        previewText: 'Invoice #{invoiceNumber} from {company} - Ready for review',
        subject: 'Invoice #{invoiceNumber} from {company}',
        recipientEmail: 'Recipient Email',
        contactName: 'Contact Name',
        contactNamePlaceholder: 'Contact person name',
        messageLabel: 'Custom Message',
        messagePlaceholder: 'Add a personal message to your invoice email...',
        invalidEmail: 'Please enter a valid email address',
        previewTitle: 'Email Preview',
        send: 'Send',
        greeting: 'Dear',
        defaultMessage: 'Thank you for choosing {company}. Please find your invoice ({invoiceNumber}) attached below.\n\nBest regards,\n{company}',
        reminderSubject: 'Payment Reminder: Invoice #{invoiceNumber} from {company}',
        reminderHeader: 'This is a friendly reminder that payment for this invoice is overdue.',
        reminderDefaultMessage: 'This is a friendly reminder that invoice {invoiceNumber} from {company} is now overdue. We kindly request that you process the payment at your earliest convenience.\n\nIf you have already made the payment, please disregard this message.\n\nThank you for your attention to this matter.\n\nBest regards,\n{company}',
        history: 'History',
        success: {
            title: 'Invoice sent!',
            description: 'Your invoice has been successfully sent to {email}'
        },
        reminderSuccess: {
            title: 'Reminder sent!',
            description: 'Payment reminder has been sent to {email}'
        },
        reminderCooldownError: 'You can send the next reminder {time}',
        reminderTooSoon: 'Reminder was sent recently. Please wait 24 hours between reminders.'
    },
    emailHistory: {
        queued: 'Email Queued',
        sent: 'Email Sent',
        failed: 'Email Failed',
        reminderQueued: 'Reminder Queued',
        reminderSent: 'Reminder Sent',
        to: 'To: {email}',
        failedDescription: 'To: {email}{error, select, false {} other { - {error}}}'
    },
    period: {
        title: 'Time Period',
        custom: 'Custom Range',
        selectDates: 'Select date range',
        month: 'Month',
        currentMonth: 'Current Month',
        previousMonth: 'Previous Month',
        apply: 'Apply',
        presets: {
            title: 'Presets',
            currentMonth: 'Current Month',
            previousMonth: 'Previous Month',
            currentQuarter: 'Current Quarter',
            previousQuarter: 'Previous Quarter',
            currentYear: 'Current Year',
            previousYear: 'Previous Year',
            last30Days: 'Last 30 Days',
            last90Days: 'Last 90 Days',
            yearToDate: 'Year to Date',
            today: 'Today',
            yesterday: 'Yesterday',
            last7days: 'Last 7 days',
            last30days: 'Last 30 days',
            thisMonth: 'This month',
            lastMonth: 'Last month',
            thisQuarter: 'This quarter',
            lastQuarter: 'Last quarter',
            thisYear: 'This year',
            lastYear: 'Last year'
        }
    },
    schedule: {
        title: 'Recurring Schedule',
        create: 'Schedule Recurring',
        edit: 'Edit Schedule',
        type: 'Frequency',
        monthly: 'Monthly',
        quarterly: 'Quarterly',
        yearly: 'Yearly',
        day: 'Day',
        dayOfMonth: 'of the month',
        dayHelp: 'If the day exceeds the month\'s days, the last day will be used.',
        dayError: 'Day must be between 1 and 31',
        dayFromStartDate: 'Will recur on day {day} of each period',
        dateSync: 'This is also the invoice date',
        startDate: 'Start Date',
        endDate: 'End Date',
        optional: 'optional',
        endDateError: 'End date must be after start date',
        nextInvoice: 'Next invoice',
        until: 'Until',
        description: '{type} on day {day}',
        notScheduled: 'Not scheduled',
        clickToSetup: 'Click to set up recurring',
        confirmDelete: 'Are you sure you want to delete this schedule?',
        scheduled: 'Scheduled',
    },
    navigation: {
        features: 'Features',
        pricing: 'Pricing',
        contact: 'Contact',
        login: 'Login',
    },
    footer: {
        about: 'About',
        resources: 'Resources',
        account: 'Account',
        support: 'Support',
        blog: 'Blog',
        faq: 'FAQ',
        login: 'Login',
        feedback: 'Bugs & Feedback',
        privacyPolicy: 'Privacy Policy',
        termsOfService: 'Terms of Service',
        copyright: '© {year} {company}. All rights reserved.',
        backToTop: 'Back to top',
    },
    easySection: {
        title: 'Invoicing made REALLY easy',
        subtitle: 'Create beautiful invoices with ease, leave complexities to us.',
        oneClickInvoice: {
            title: 'Very easy to use',
            description: 'Create your invoice in seconds, with our intuitive interface and one-click generation.'
        },
        intuitiveWorkflow: {
            title: 'Invoices That Make You Look Professional',
            description: 'With our beautiful invoices, you can easily manage your invoices without complex steps or accounting knowledge.'
        },
        paymentOptions: {
            title: 'All payment methods',
            description: 'Support for all major payment methods including credit cards, Apple Pay, iDeal, Klarna, SEPA, PayPal and more.'
        },
        cloudSync: {
            title: 'All invoices in one place',
            description: 'Access your invoices from anywhere with our secure cloud storage. Never lose an important document again.'
        }
    },
    faq: {
        title: 'Frequently asked questions',
        subtitle: 'We are here to help you with any questions you may have. If you don\'t find what you need, please visit our',
        completeFaqLink: 'complete FAQ page'
    },
    seo: {
        title: 'InvoiceHappens - Create Invoices in Seconds',
        description: 'Create professional invoices in seconds with InvoiceHappens. 100% free for entrepreneurs. No credit card required.',
        defaultTitle: 'InvoiceHappens - Create Beautiful Invoices Instantly',
        defaultDescription: 'Create and send professional invoices in seconds with no sign-ups and no fees. The elegant invoicing platform for entrepreneurs.',
        home: {
            title: 'InvoiceHappens - Create Beautiful Invoices Instantly',
            description: 'Create and send professional invoices in seconds with no sign-ups and no fees. The elegant invoicing platform for entrepreneurs.'
        },
        features: {
            title: 'Features - InvoiceHappens',
            description: 'Discover the powerful features of InvoiceHappens: instant invoice creation, beautiful templates, cloud sync, and more.'
        },
        pricing: {
            title: 'Pricing - InvoiceHappens',
            description: 'Simple, transparent pricing with no hidden fees. Start invoicing for free today.'
        },
        contact: {
            title: 'Contact Us - InvoiceHappens',
            description: 'Have questions or feedback? Get in touch with our team. We\'re here to help.'
        },
        faq: {
            title: 'Frequently Asked Questions - InvoiceHappens',
            description: 'Find answers to common questions about InvoiceHappens, our features, pricing, and more.'
        },
        termsOfService: {
            title: 'Terms of Service - InvoiceHappens',
            description: 'Read our terms of service to understand the rules and guidelines for using InvoiceHappens.'
        },
        privacyPolicy: {
            title: 'Privacy Policy - InvoiceHappens',
            description: 'Learn how we collect, use, and protect your personal information at InvoiceHappens.'
        },
        invoiceStatus: {
            title: 'Invoice Status - InvoiceHappens',
            description: 'Check the status of your invoice and payment information.'
        }
    },
    notFound: {
        title: 'Page Not Found',
        message: 'The page you are looking for doesn\'t exist or has been moved.',
        backHome: 'Back to Home'
    },
};
